(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vunro-footer-signup"] && !Shopify.designMode) return;
  try {
    
/*
 * VUNRO | Klaviyo phone field: pre-select the visitor's country
 * Added 21 Sep 2026 (Claude, at the owner's request). Safe to delete: nothing else depends on it.
 *
 * WHY: Klaviyo's phone-number field (the "Text Opt-In" step of pop-up XMHD2D and the SMS
 * rewards form U3ajMs) always opens on its fixed "Default country" (United States, +1).
 * Klaviyo has no geo / auto-detect option, so a UK visitor on uk.getvunro.com saw the US
 * flag and had to change it by hand. This script selects the visitor's Shopify market
 * country in Klaviyo's country picker, once, before they type.
 *
 * HOW: reads window.Shopify.country (the active market, e.g. "GB"). If it is one of the
 * markets where VUNRO can send texts (list below), it opens Klaviyo's country list while
 * the list is kept invisible, clicks the matching entry (which also closes the list) and
 * puts keyboard focus back where it was. The US needs nothing (it is Klaviyo's default)
 * and every other country is left alone.
 *
 * PERFORMANCE: Shopify bundles section JavaScript into one deferred file, so this never
 * blocks rendering. It exits at once for the US and for unlisted markets. Otherwise it
 * only runs one querySelector a few times after a Klaviyo form event or a click inside a
 * Klaviyo form. No polling loop, no MutationObserver, no network requests.
 *
 * FAILS SAFE: if Klaviyo changes its markup the selectors match nothing and the flag
 * stays on the US default, exactly as before. Each picker is attempted once, so a
 * visitor's own choice is never overridden.
 *
 * TO EXTEND: when a new SMS sender country is approved in Klaviyo, add its ISO code and
 * the exact English name Klaviyo shows in its country list (label format "Name+code").
 */
(function () {
  'use strict';

  var MARKETS = {
    AU: 'Australia', NL: 'Netherlands', GB: 'United Kingdom', CA: 'Canada', FR: 'France', DE: 'Germany',
    CH: 'Switzerland', SE: 'Sweden', NO: 'Norway', DK: 'Denmark',
    IT: 'Italy', PT: 'Portugal', PL: 'Poland', LU: 'Luxembourg'
  };
  var wanted = MARKETS[window.Shopify && window.Shopify.country];
  if (!wanted) return; // US (Klaviyo's default) and unlisted markets: nothing to do

  var PICKER = 'button[role="combobox"][aria-label="Search Countries"]';
  var busy = false;

  function finish(hideStyle, previousFocus) {
    // Klaviyo moves focus to its picker after a selection; wait for that, then restore.
    setTimeout(function () {
      if (hideStyle.parentNode) hideStyle.parentNode.removeChild(hideStyle);
      if (previousFocus && previousFocus !== document.body && document.contains(previousFocus)) {
        try { previousFocus.focus({ preventScroll: true }); } catch (e) {}
      } else if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      busy = false;
    }, 250);
  }

  function switchPicker(button) {
    button.setAttribute('data-vunro-country', 'done'); // one attempt per picker
    var flag = button.querySelector('img');
    if (flag && flag.getAttribute('aria-label') === wanted) return;

    busy = true;
    var previousFocus = document.activeElement;
    var hideStyle = document.createElement('style'); // keeps the list invisible while it is open
    hideStyle.textContent = '[id^="downshift-"][role="listbox"]{visibility:hidden!important}';
    document.head.appendChild(hideStyle);

    button.click(); // opens Klaviyo's country list
    var tries = 0;
    (function pick() {
      var options = document.querySelectorAll('[role="listbox"] [role="option"]');
      var match = null;
      for (var i = 0; i < options.length; i++) {
        if (options[i].textContent.trim().indexOf(wanted + '+') === 0) { match = options[i]; break; }
      }
      if (match) {
        match.click(); // selects the country and closes the list
        finish(hideStyle, previousFocus);
      } else if (++tries < 10) {
        setTimeout(pick, 50); // list not rendered yet
      } else {
        // give up quietly: close the list again and leave Klaviyo's default in place
        button.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, which: 27, bubbles: true }));
        finish(hideStyle, previousFocus);
      }
    })();
  }

  function check() {
    if (busy) return;
    var button = document.querySelector(PICKER + ':not([data-vunro-country])');
    if (button) switchPicker(button);
  }

  function schedule() {
    // a phone step appears shortly after a form opens or its email step is submitted
    [150, 600, 1500, 3000, 5000].forEach(function (ms) { setTimeout(check, ms); });
  }

  window.addEventListener('klaviyoForms', schedule); // Klaviyo form events: open, embedOpen, stepSubmit, submit
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('form.klaviyo-form')) schedule();
  }, { passive: true });
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule);
})();

  } catch(e) { console.error(e); }
})();
})();
